import { CARD_SIZES } from 'cards/constants/Cards';
import { CARD_TYPES } from 'cards/components/CardListing/types';

export enum ORIENTATION {
  portrait = 'PORTRAIT',
  landscape = 'LANDSCAPE',
}

export type CardTemplateBackgroundsRequest = {
  cardType: CARD_TYPES;
  orientation: ORIENTATION;
  size: keyof typeof CARD_SIZES;
  variationUuid?: string;
};
